/* eslint-disable */
exports.USER_TYPE = {
  MASTER_ADMIN: 'master_admin',
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  DOCTOR: 'doctor',
  ADMIN_DOCTOR: 'admin_doctor',
  NURSE: 'nurse',
  PATIENT: 'patient',
  ADMIN_NURSE: 'admin_nurse',
  ADMIN_DERMAL_THERAPIST: 'admin_dermal_therapist',
  DERMAL_THERAPIST: 'dermal_therapist',
};
exports.PROVIDER_TYPE_LIST = [
  { _id: 'all', label: 'All' },
  { _id: 'admin_dermal_therapist', label: 'Admin & Dermal Therapist' },
  { _id: 'admin_nurse', label: 'Admin & Nurse' },
  {
    _id: 'admin_doctor',
    label: 'Admin & Doctor',
  },
  { _id: 'doctor', label: 'Doctor' },
  { _id: 'dermal_therapist', label: 'Dermal Therapist' },
  { _id: 'nurse', label: 'Nurse' },
];
exports.userTypeMapping = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  doctor: 'Doctor',
  admin_doctor: 'Admin & Doctor',
  nurse: 'Nurse',
  admin_nurse: 'Admin & Nurse',
  dermal_therapist: 'Dermal Therapist',
  admin_dermal_therapist: 'Admin & Dermal Therapist',
};

exports.GENDER = {
  MALE: 'male',
  FEMALE: 'female',
};

exports.GENDER_CONVERT = {
  male: 'Male',
  female: 'Female',
};

exports.STATES = [
  { _id: 'ACT', label: 'Australian Capital Territory' },
  { _id: 'NSW', label: 'New South Wales' },
  { _id: 'NT', label: 'Northern Territory' },
  { _id: 'QLD', label: 'Queensland' },
  { _id: 'SA', label: 'South Australia' },
  { _id: 'TAS', label: 'Tasmania' },
  { _id: 'VIC', label: 'Victoria' },
  { _id: 'WA', label: 'Western Australia' },
];

exports.COMMUNICATION_METHOD = {
  CALL: 'Call',
  EMAIL: 'Email',
};

exports.COMMUNICATION_TIME = {
  DURING_BUSINESS_H: 1,
  OUTSIDE_BUSINESS_H: 2,
  ON_WEEKENDS: 3,
  ANYTIME: 4,
};

exports.CONVERT_COMMUNICATION_TIME = {
  1: 'During Business Hours',
  2: 'Outside Business Hours',
  3: 'On Weekends',
  4: 'Anytime',
};

exports.SERVICE_TYPES = {
  INITIAL_CONSULT: 1,
  TREATMENT: 2,
  POST_TREATMENT: 3,
};

exports.BOOKING_STATUS = {
  ALL: 0,
  BOOKED: 1,
  CONFIRMED: 2,
  IN_SERVICE: 3,
  COMPLETED: 4,
  CANCELLED: 5,
  NO_SHOW: 6,
};
exports.BOOKING_STATUS_CHIP_MAP = {
  1: { label: 'Booked', color: 'yellow' },
  2: { label: 'Confirmed', color: 'info' },
  3: { label: 'In Service', color: 'primary' },
  4: { label: 'Completed', color: 'secondary' },
  5: { label: 'Cancelled', color: 'error' },
  6: { label: 'No Show', color: 'error' },
};

exports.CONVERT_SERVICE_TYPE = {
  1: 'Initial Consult',
  2: 'Treatment',
  3: 'Post Treatment',
};

exports.STOCK_STATUS = {
  IN_STOCK: 1,
  OUT_OF_STOCK: 2,
  EXPIRED: 3,
  RECALLED: 4,
};

exports.STOCK_TYPE = {
  NO_STOCK: 0,
  INJECTABLE: 1,
  OTHER: 2,
  PRODUCT: 3,
};

exports.PROTOCOL_TYPE = {
  S4_DRUG: 1,
  OTHER: 2,
};

exports.STOCK_CHANGE_TYPE = {
  USE_STOCK: 1,
  UPDATE_STATUS: 2,
  UN_USE_STOCK: 3,
};

exports.S4_DRUG_PROTOCOL_STATUS = {
  NEW: 1,
  CURRENT: 2,
  EXPIRED: 3,
};

exports.CONVERT_S4_DRUG_PROTOCOL_STATUS = {
  1: 'NEW',
  2: 'CURRENT',
  3: 'EXPIRED',
};

exports.CONSENT_FORM_STATUS = {
  OPEN: 1,
  COMPLETED: 2,
  EXPIRED: 3,
};

exports.MEDICAL_HISTORY_STATUS = {
  OPEN: 1,
  COMPLETED: 2,
  EXPIRED: 3,
};

exports.STOCK_CHANGE_METHOD = {
  TREATMENT: 1,
  MANUALLY: 2,
  AUTOMATICALLY: 3,
};

exports.HPII_STATUS = {
  ACTIVE: 'A',
  DEACTIVATED: 'D',
  RETIRED: 'R',
};

exports.USER_QUALIFICATION = {
  ADMIN: 'Practice Administrator',
};

exports.PROMOTION_SELECT = [
  { _id: 'everyone', val: 'who are in our database' },
  {
    _id: 'treatmentPreviously',
    val: 'who have received treatments from us previously',
  },
  {
    _id: 'specificTreatment',
    val: 'who have received a specific treatment from us',
  },
  {
    _id: 'specificTreatmentArea',
    val: 'who have received a specific area of treatment from us',
  },
  { _id: 'ageRange', val: 'who are aged between' },
];

exports.CONSENT_FORM_STATUS_REVERSE = {
  1: 'Open',
  2: 'Completed',
  3: 'Expired',
};

exports.STOCK_STATUS_REVERSE = {
  1: 'In Stock',
  2: 'Out of Stock',
  3: 'Expired',
  4: 'Recalled',
};

exports.SERVICE_TYPES_REVERSE = {
  1: 'Initial Consult',
  2: 'Treatment',
  3: 'Post Treatment',
};

exports.putCommasOnNumber = (numberToPutComma) => {
  return new Intl.NumberFormat('en-AU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(numberToPutComma);
};

const BASE_TEMPLATE_VARIABLES = [
  'PATIENT_NAME',
  'CLINIC_NAME',
  'CLINIC_PHONE',
  'CLINIC_EMAIL',
  'CLINIC_ADDRESS',
  'PARKING_INSTRUCTION',
  'PROVIDER_NAME',
  'PROVIDER_QUALIFICATION',
  'BOOKING_DATE',
  'BOOKING_TIME',
  'ESTIMATED_DURATION',
];

exports.AUTOMATIC_REMINDER_TEMPLATE_VARIABLES = {
  INITIAL_CONSULT_CONFIRMATION: [...BASE_TEMPLATE_VARIABLES, 'TREATMENTS'],
  TREATMENT_CONFIRMATION: [...BASE_TEMPLATE_VARIABLES, 'TREATMENTS'],
  POST_TREATMENT_CONFIRMATION: [...BASE_TEMPLATE_VARIABLES, 'TREATMENTS'],
  POST_CARE: [...BASE_TEMPLATE_VARIABLES, 'ONLINE_BOOKING_URL', 'DETAILED_TREATMENTS'],
  ONE_DAY_BEFORE_BOOKING: [...BASE_TEMPLATE_VARIABLES, 'TREATMENTS', 'BOOKING_CONFIRM_URL'],
  POST_ANTI_WRINKLE: [...BASE_TEMPLATE_VARIABLES],
  POST_DERMAL_FILLER: [...BASE_TEMPLATE_VARIABLES],
};

exports.AUTOMATIC_REMINDER_TEMPLATES = {
  INITIAL_CONSULT_CONFIRMATION: {
    name: 'Booking Confirmation - Your Initial Consult',
    description: 'Sent to Client When Initial Consult Booked (by Client or Provider)',
  },
  TREATMENT_CONFIRMATION: {
    name: 'Booking Confirmation - Your Appointment',
    description: 'Sent to Client When Treatment Consult Booked (by Client or Provider)',
  },
  POST_TREATMENT_CONFIRMATION: {
    name: 'Booking Confirmation - Your Post-Treatment Consult',
    description: 'Sent to Client When Post-Treatment Consult Booked (by Client or Provider)',
  },
  POST_CARE: {
    name: 'Post-Care - Your Recent Treatment',
    description: 'Sent to Client Once Provider has Updated Booking Status to Completed',
  },
  ONE_DAY_BEFORE_BOOKING: {
    name: "Tick - Tock, Beauty O'Clock! Your Appointment is Just Around the Corner!",
    description: 'Sent to Client 1 Day Prior of Appointment Date',
  },
  POST_ANTI_WRINKLE: {
    name: 'Post Anti-Wrinkle Treatment Follow-Up (Please Read)',
    description: 'Sent to Client 14 Day After Completed Booking of Anti-Wrinkle Treatment',
  },
  POST_DERMAL_FILLER: {
    name: 'Post Dermal Filler Follow-Up (Please Read)',
    description: 'Sent to Client 1 Day After Completed Booking of Dermal Filler Treatment',
  },
};

exports.MAPPED_AUTOMATIC_CONFIRMATION_REMINDERS = {
  '1_DAYS_BEFORE_REMINDER':
    "Tick-Tock, Beauty O'Clock! Your Appointment is Just Around the Corner at [Clinic Name]!",
  '2_DAYS_BEFORE_REMINDER':
    "Tick-Tock, Beauty O'Clock! Your Appointment is Just Around the Corner at [Clinic Name]!",
  DERMAL_FILLER_FOLLOW_UP: '[Clinic Name] Post Dermal Filler Follow-Up (Please Read)',
  ANTI_WRINKLE_FOLLOW_UP: '[Clinic Name] Post Anti-Wrinkle Treatment Follow-Up (Please Read)',
  POST_CARE_COMPLETED: '[Clinic Name] Post-Care - Your Recent Treatment',
  INITIAL_CONSULT: '[Clinic Name] Booking Confirmation - Your Initial Consult',
  TREATMENT: '[Clinic Name] Booking Confirmation - Your Appointment',
  POST_TREATMENT: '[Clinic Name] Booking Confirmation - Your Post-Treatment Consult',
};

exports.MAPPED_DEFAULT_NOTIFICATION_RADIO_BTN_TITLES = {
  hollywood: 'Hollywood',
  // 'sass': "Sass",
  laugh: 'Laugh',
  envy: 'Envy',
  OTHER: 'Other',
};

exports.MAPPED_STOCK_UPDATE_STATUS = {
  expired: 'Expired',
  unexplained: 'Unexplained',
};
exports.TEMPLATE_COMPONENT_IDENTIFIER = {
  PATIENT_RECORD_NOTIFICATION: 1,
  BOOKING_RECORD_NOTIFICATION: 2,
  PROMOTIONAL_EMAILS: 3,
  PERFORMANCE_RECORD_NOTIFICATION: 4,
};
exports.SMS_AND_EMAIL_TEMPLATES = [
  {
    title: 'Hollywood',
    displayOnComponent: [
      this.TEMPLATE_COMPONENT_IDENTIFIER.PATIENT_RECORD_NOTIFICATION,
      this.TEMPLATE_COMPONENT_IDENTIFIER.BOOKING_RECORD_NOTIFICATION,
      this.TEMPLATE_COMPONENT_IDENTIFIER.PROMOTIONAL_EMAILS,
    ],
    template:
      'Ready to look as fabulous as your favorite Hollywood star? LA Lips® is here to make you feel like a million bucks (without the price tag)! Get ready for the red carpet treatment and prepare to dazzle. Book your appointment today and let us turn heads together!\n\nBook Now: <clinic-booking-url> \n\nLA Lips®💋 INJECTING NOW…\n\nIf you’d like to stop receiving promotional updates from LA Lips®, you can unsubscribe here: <unsubscribe-url>',
  },
  // {
  //   title: "Sass",
  //   displayOnComponent: [
  //     this.TEMPLATE_COMPONENT_IDENTIFIER.PATIENT_RECORD_NOTIFICATION,
  //     this.TEMPLATE_COMPONENT_IDENTIFIER.BOOKING_RECORD_NOTIFICATION,
  //     this.TEMPLATE_COMPONENT_IDENTIFIER.PROMOTIONAL_EMAILS,
  //   ],
  //   template: "Inject some laughter into your beauty routine! Our cosmetic injectable treatments not only make you look amazing, but they also come with a free side of confidence and a pinch of sass. Embrace your inner diva and let our talented team work their magic. Trust us, you'll leave feeling like the queen of the catwalk!\n\nBook Now: <clinic-booking-url> \n\nLove from your #1 fan, LA Lips®💋 INJECTING NOW…"
  // },
  {
    title: 'Laugh',
    displayOnComponent: [
      this.TEMPLATE_COMPONENT_IDENTIFIER.PATIENT_RECORD_NOTIFICATION,
      this.TEMPLATE_COMPONENT_IDENTIFIER.BOOKING_RECORD_NOTIFICATION,
      this.TEMPLATE_COMPONENT_IDENTIFIER.PROMOTIONAL_EMAILS,
    ],
    template:
      'Why settle for frown lines when you can have laugh lines instead? LA Lips® is your secret weapon against wrinkles and gloomy days. Let our skilled practitioners inject some joy into your life (and face) with our state-of-the-art treatments. Smile, laugh, and enjoy a younger-looking you!\n\nBook Now: <clinic-booking-url> \n\nLA Lips®💋 INJECTING NOW…\n\nIf you’d like to stop receiving promotional updates from LA Lips®, you can unsubscribe here: <unsubscribe-url>',
  },
  {
    title: 'Envy',
    displayOnComponent: [
      this.TEMPLATE_COMPONENT_IDENTIFIER.PATIENT_RECORD_NOTIFICATION,
      this.TEMPLATE_COMPONENT_IDENTIFIER.BOOKING_RECORD_NOTIFICATION,
      this.TEMPLATE_COMPONENT_IDENTIFIER.PROMOTIONAL_EMAILS,
    ],
    template:
      "Warning: our cosmetic injectable clinic has been known to cause excessive compliments and envious stares! Proceed with caution if you're not ready for a sudden boost in self-esteem and a barrage of 'Wow, you look incredible!' comments. Be ready to unleash your inner knockout, don't wait any longer. Join the ranks of our happy clients (if you aren’t already one) and prepare for a life filled with beauty and laughter!\n\nBook Now: <clinic-booking-url> \n\nLA Lips®💋 INJECTING NOW…\n\nIf you’d like to stop receiving promotional updates from LA Lips®, you can unsubscribe here: <unsubscribe-url>",
  },
  {
    title: 'Custom',
    displayOnComponent: [this.TEMPLATE_COMPONENT_IDENTIFIER.PROMOTIONAL_EMAILS],
    template: '',
  },
  {
    title: 'Post Care\nAnti-Wrinkle',
    displayOnComponent: [this.TEMPLATE_COMPONENT_IDENTIFIER.BOOKING_RECORD_NOTIFICATION],
    template:
      'Hi doll. Just a quick follow-up regarding the treatment you had with us 2 weeks ago.\n\n• Are you happy with your treatment? \n• Have we achieved your desired outcome? \n• Do you still have desired movement when animating? \n\nIf you answered no to any of these questions, or simply want to tell or ask us something, please call us on <clinic-phone>. Your results, confidence and safety are our number one priority.\n\n<provider-full-name>\n<provider-qualification>\n\n<clinic-name> 💋\n<clinic-phone>\n<clinic-email>\nlalips.com.au',
  },
  {
    title: 'Post Care Dermal Filler',
    displayOnComponent: [this.TEMPLATE_COMPONENT_IDENTIFIER.BOOKING_RECORD_NOTIFICATION],
    template:
      'Hi doll. Just a quick follow-up regarding the treatment you had with us yesterday.\n\n• Are you experiencing any tenderness or bruising?\n• Are you experiencing any pain of 5 or higher on a scale of 1-10?\n• Do you have any discolouration of the skin?\n• Are you experiencing any pain in an area that was not treated by us?\n\nIf you answered yes to any of these questions, or simply want to tell or ask us something, please call us on <clinic-phone>. Your results, confidence and safety are our number one priority.\n\n<provider-full-name>\n<provider-qualification>\n\n<clinic-name> 💋\n<clinic-phone>\n<clinic-email>\nlalips.com.au',
  },
  {
    title: 'Client Retention',
    displayOnComponent: [this.TEMPLATE_COMPONENT_IDENTIFIER.PERFORMANCE_RECORD_NOTIFICATION],
    template:
      "Hi <client-name>, it's <user-first-name> from LA Lips®💋 \n\nIt's been a few months since your last visit, and I wanted to do a quick check-in! We currently have exclusive promotions on our treatments. Now's the perfect time to schedule your next appointment. I don't want you to miss out. \n\nYou can visit our IG highlights https://www.instagram.com/stories/highlights/17896809266934231/ to find out more about our current promos 💖 \n\nBook in soon before my appointments fill up. Visit \nhttps://booking.instanttouch.com.au/lalips > Select 'LA Lips® <clinic-name>' > Select '<provider-full-name>' or call me on <clinic-phone>. \n\nHope to see you doll! x\n\nIf you’d like to stop receiving promotional updates from LA Lips®, you can unsubscribe here: <unsubscribe-url>",
  },
  {
    title: 'Check In / Price List',
    displayOnComponent: [this.TEMPLATE_COMPONENT_IDENTIFIER.PERFORMANCE_RECORD_NOTIFICATION],
    template:
      "Hi <patient-first-name>, it's <user-first-name> from LA Lips®💋\n\nIt's been a minute since you viewed our price list, and I wanted to do a quick check-in! We currently have exclusive promotions on our treatments. Now's the perfect time to schedule your next appointment. I don't want you to miss out.\n\nYou can visit our IG highlights \nhttps://www.instagram.com/stories/highlights/17896809266934231/ to find out more about our current promos 💖 \n\nBook in soon before appointments fill up. Visit \nhttps://booking.instanttouch.com.au/lalips > Select your nearest LA Lips® > Select a provider of your choice or call us at <clinic-name> on <clinic-phone>. \n\nHope to see you doll! x",
  },
];

exports.PATIENT_NOTIFICATION_TYPE = {
  DEFAULT: 1,
  PRICE_LIST_CONVERSION: 2,
  CLIENT_RETENTION: 3,
};

exports.FIELD_TYPES = {
  OPEN_TEXT: 'Open Text',
  MINS: 'mins',
  MM: 'mm',
  CALENDAR: 'Calendar',
  DROPDOWN: 'Drop Down',
};

exports.PAYMENT_LOG_TYPE = {
  APPLIED_PAYMENT: 1,
  APPLIED_REFUND: 2,
  DELETED_PAYMENT: 3,
  DELETED_REFUND: 4,
  SEND_RECEIPT: 5,
  PREVIEW_RECEIPT: 6,
};
exports.MAPPED_PAYMENT_LOG_TYPE = {
  1: 'Applied Payment',
  2: 'Applied Refund',
  3: 'Deleted Payment',
  4: 'Deleted Refund',
  5: 'Send Receipt',
  6: 'Preview Receipt',
};

exports.FILE_TYPES = {
  IMAGE: 'image',
  PDF: 'pdf',
  HTML: 'html',
  CSV: 'csv',
};
exports.FILE_TYPE_EXTENSIONS = {
  image: ['jpg', 'jpeg', 'png', 'svg'],
  pdf: ['pdf'],
  html: ['html'],
  csv: ['csv'],
};

exports.PROMOTION_TYPE = {
  CLINIC_PATIENTS: 1,
  CUSTOM_PATIENTS: 2,
};

exports.PROMOTION_EXPORT_TYPE = {
  COMPLETED_BOOKINGS: 'completed',
  NEVER_BOOKED: 'neverBooked',
};

exports.VOUCHER_TYPE = {
  PROMOTION: 'Promotion',
  REFER_FRIEND: 'Refer a Friend',
};
